import { api } from 'api';
import type { CcpBranch } from 'types/CcpBranch';
import type { List } from 'types/List';
import { Url } from 'utils/constants';

export const getBranchesForPOS = ({ posId }: { posId: string }): Promise<List<CcpBranch>> =>
  api.get(`${Url.KITCHEN_MANAGEMENT_API_URL}/point-of-sale/${posId}/branches`);
